/** Colours assigned to cascade tiers, resolved from CSS custom properties. */
export const TIER_COLORS = ['var(--tier-1)', 'var(--tier-2)', 'var(--tier-3)', 'var(--tier-4)'];

/** Colour for tier `index`, cycling for designs with more than four tiers. */
export function tierColor(index: number): string {
  return TIER_COLORS[Math.abs(index) % TIER_COLORS.length];
}

/**
 * Round a maximum up to a friendly 1/2/5 × 10^n value so axis labels land on
 * readable numbers instead of on the data's own ragged maximum.
 */
export function niceMax(value: number): number {
  if (!Number.isFinite(value) || value <= 0) return 1;
  const magnitude = 10 ** Math.floor(Math.log10(value));
  const normalised = value / magnitude;
  const step = normalised <= 1 ? 1 : normalised <= 2 ? 2 : normalised <= 5 ? 5 : 10;
  return step * magnitude;
}
